module.exports = __webpack_public_path__ + "img/img-2.863ff5db.jpg";